import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  ButtonAction,
  MenuTable,
  MenuTableDivider,
  MenuTableItem,
  Table,
  TableContainer,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../components/Table/styles";
import Button from "../../../../components/Button/button";
import { Colors } from "../../../../shared/colors/colors";
import { GetDadosFinanceirosDto } from "../../../../shared/dtos/DadosFinanceiros.dto";
import dadosFinanceirosService from "../../../../services/DadosFinanceirosService";
import { ButtonGroupEnd } from "../../../../shared/styles/global.styles";
import DadosFinanceirosModal from "../../../../components/DadosFinanceirosModal/dadosFinanceiros.modal";
import { IoMdClose } from "react-icons/io";
import { SlOptionsVertical } from "react-icons/sl";
import { GetContribuinteDto } from "../../../../shared/dtos/Contribuinte.dto";
import { MdOutlineViewColumn } from "react-icons/md";
import { Dropdown } from "react-bootstrap";
import {
  DropdownDivider,
  DropdownScroll,
} from "../../../../components/Dropdowns/styles";
import { ContainerButtons, ContainerFilter } from "../../style";
import { MainContainer } from "./dadosFinanceiro.styles";

interface Props {
  contribuinteData: GetContribuinteDto;
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
  setCancelFutureInstallmentsIds: React.Dispatch<
    React.SetStateAction<number[]>
  >;
  newFlow: boolean;
  setNewFlow: React.Dispatch<React.SetStateAction<boolean>>;
  editOnly: boolean;
}

const DadosFinanceirosList: React.FC<Props> = ({
  contribuinteData,
  setSelectedTab,
  setCancelFutureInstallmentsIds,
  newFlow,
  setNewFlow,
  editOnly,
}) => {
  const menuRefsMap = useRef<Map<number, HTMLDivElement | null>>(new Map());
  const [dadosFinanceiros, setDadosFinanceiros] = useState<
    GetDadosFinanceirosDto[]
  >([]);
  const [selectedDadoFinanceiro, setSelectedDadoFinanceiro] =
    useState<GetDadosFinanceirosDto>();
  const [lastDadoFinanceiro, setLastDadoFinanceiro] =
    useState<GetDadosFinanceirosDto>();
  // const [lastMovimentacao, setLastMovimentacao] =
  //   useState<GetMovimentacaoDto>();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isOpenDropdown, setIsOpenDropdown] = useState<number | null>(null);

  const defaultColumns = [
    "Status",
    "Data de Inclusão",
    "Local de Pagamento",
    "Frequencia Parcelas",
    "Valor Titular",
  ];

  // Função para garantir que sempre tenhamos pelo menos as colunas padrão
  const ensureDefaultColumns = (columns: string[]) => {
    return columns.length > 0 ? columns : defaultColumns;
  };

  const loadVisibleColumns = () => {
    try {
      const savedColumns = sessionStorage.getItem(
        "visibleColumnsDadosFinanceiros"
      );
      if (!savedColumns) return defaultColumns;

      const parsedColumns = JSON.parse(savedColumns);
      return ensureDefaultColumns(parsedColumns);
    } catch (error) {
      console.error("Erro ao carregar colunas:", error);
      return defaultColumns;
    }
  };

  const [dadosFinanceirosVisibleColumns, setVisibleColumns] = useState<
    string[]
  >(loadVisibleColumns());
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>(
    loadVisibleColumns()
  );
  const [isOpenMenuCollumn, setIsOpenMenuCollumn] = useState(false);
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);

  const fecthDadosFinanceiros = async () => {
    setLoading(true);
    try {
      // Verifica se o objeto 'contribuinte' e seu 'id' estão disponíveis
      if (contribuinteData.id) {
        await dadosFinanceirosService
          .getDadosFinanceirosByContribuinte(contribuinteData.id)
          .then((response) => {
            setDadosFinanceiros(response);

            // Pega o ultimo dado financeiro cadastrado
            if (response[response.length - 1]?.dataExclusao) {
              setLastDadoFinanceiro(response[response.length - 1]);
            }
          });

        // const lastDadosFinanceiro = dadosFinanceiros[0];
        // if (lastDadosFinanceiro?.dataExclusao) {
        //   setLastDadoFinanceiro(lastDadosFinanceiro);
        // }
      }
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao buscar os dados do contribuinte. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleShowModal = () => {
    if (
      contribuinteData.LastMovimentacao &&
      contribuinteData.LastMovimentacao.tipo === "EXCLUSAO"
    ) {
      Swal.fire({
        title: "Alerta",
        text: "Você não pode criar um novo dado financeiro pois a última movimentação do contribuinte foi uma exclusão.",
        icon: "warning",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else if (dadosFinanceiros.some((dado) => !dado.dataExclusao)) {
      Swal.fire({
        title: "Alerta",
        text: "Você não pode criar um novo dado financeiro pois o contribuinte já possui um dado financeiro ativo.",
        icon: "warning",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else {
      setShowModal(true);
    }
  };

  const handleSelectDados = (dados: GetDadosFinanceirosDto) => {
    if (
      contribuinteData.LastMovimentacao &&
      contribuinteData.LastMovimentacao.tipo === "EXCLUSAO"
    ) {
      Swal.fire({
        title: "Contribuinte com dados financeiros inativos",
        text: "Não será possível editar o dado financeiro, pois a última movimentação do contribuinte foi uma exclusão.",
        icon: "warning",
        confirmButtonText: "Acessar dados financeiros",
        showCancelButton: true,
        cancelButtonText: "Fechar",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setSelectedDadoFinanceiro(dados);
          setShowModal(true);
          setIsOpenDropdown(null);
        } else {
          setIsOpenDropdown(null);
        }
      });
    } else {
      setSelectedDadoFinanceiro(dados);
      setShowModal(true);
      setIsOpenDropdown(null);
    }
  };

  const toggleDropdown = (id: number) => {
    setIsOpenDropdown(id === isOpenDropdown ? null : id);
  };

  useEffect(() => {
    if (isOpenMenuCollumn) {
      setTempVisibleColumns(dadosFinanceirosVisibleColumns); // Inicializa o estado temporário com as colunas visíveis atuais
    }
  }, [isOpenMenuCollumn, dadosFinanceirosVisibleColumns]);

  // Função para alternar colunas no estado temporário
  const handleColumnToggle = (column: string) => {
    // Se a coluna é padrão, não permite desmarcar
    if (defaultColumns.includes(column)) {
      return;
    }

    setTempVisibleColumns((prev: string[]) => {
      return prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column];
    });
  };

  // Função para aplicar as mudanças
  const handleApplyColumns = () => {
    const columnsToSave = ensureDefaultColumns(tempVisibleColumns);
    setVisibleColumns(columnsToSave);
    sessionStorage.setItem(
      "visibleColumnsDadosFinanceiros",
      JSON.stringify(columnsToSave)
    );
    setIsOpenMenuCollumn(false);
  };

  useEffect(() => {
    // Função para fechar o menu se o clique for fora dele
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpenMenuCollumn(false); // Fecha o dropdown
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpenMenuCollumn) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenMenuCollumn]);

  useEffect(() => {
    if (newFlow && !showModal) {
      setShowModal(true);
    }
  }, [newFlow]);

  useEffect(() => {
    fecthDadosFinanceiros();
  }, []);

  const formatarValorEmReais = (valor: string) => {
    if (!valor) return "R$ 0,00";

    // Se o valor já estiver no formato numérico com ponto como separador decimal, converte diretamente para número
    const numero = parseFloat(valor.replace(",", "."));

    // Verifica se o valor é um número válido
    if (isNaN(numero)) return "R$ 0,00";

    // Formata o número para reais com separadores corretos
    return numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  return (
    <MainContainer>
      <div className="page contribuinte">
        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}
        <div className="body taxpayer">
          <ButtonGroupEnd>
            <ContainerFilter>
              <div></div>
              <ContainerButtons>
                <Button
                  schemaButton="out-primary"
                  action={() => {
                    setIsOpenMenuCollumn(!isOpenMenuCollumn);
                  }}
                  icon={
                    <MdOutlineViewColumn
                      size={20}
                      style={{ marginRight: "8px" }}
                    />
                  }
                >
                  Colunas
                </Button>

                <Dropdown.Menu
                  ref={dropdownMenuRef}
                  show={isOpenMenuCollumn}
                  style={{ marginTop: "50px" }}
                >
                  <DropdownScroll
                    style={{
                      overflowY: "auto",
                      overflowX: "hidden",
                      wordBreak: "break-word",
                    }}
                  >
                    {[
                      "Status",
                      "Data de Inclusão",
                      "Data de Exclusão",
                      "Tipo Exclusão",
                      "Local de Pagamento",
                      "Banco",
                      "Agência",
                      "Conta Corrente",
                      "Chave Pix",
                      "Acumulo Pagamento",
                      "Frequencia Parcelas",
                      "Valor Titular",
                      "Valor Dependente",
                      "Lotacao",
                      "Imprimir",
                      "Observação",
                    ].map((column, index, array) => (
                      <React.Fragment key={column}>
                        {!defaultColumns.includes(column) && (
                          <Dropdown.Item
                            eventKey="1"
                            onClick={() => handleColumnToggle(column)}
                            style={{ color: Colors.primary }}
                          >
                            <img
                              src={
                                tempVisibleColumns.includes(column)
                                  ? "/images/checkbox-marked.svg"
                                  : "/images/checkbox-blank-outline.svg"
                              }
                              alt={
                                tempVisibleColumns.includes(column)
                                  ? defaultColumns.includes(column)
                                    ? "Bloqueado"
                                    : "Selecionado"
                                  : "Não selecionado"
                              }
                              className="checkbox-image"
                            />
                            <label>{column}</label>
                            {array
                              .filter((col) => !defaultColumns.includes(col))
                              .indexOf(column) <
                              array.filter(
                                (col) => !defaultColumns.includes(col)
                              ).length -
                                1 && <DropdownDivider />}
                          </Dropdown.Item>
                        )}
                      </React.Fragment>
                    ))}
                  </DropdownScroll>
                  {JSON.stringify(tempVisibleColumns.sort()) !==
                    JSON.stringify(dadosFinanceirosVisibleColumns.sort()) && (
                    <Dropdown.Item>
                      <MenuTableDivider />
                      <Button
                        schemaButton="with-margin"
                        action={handleApplyColumns}
                      >
                        Aplicar
                      </Button>
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
                {editOnly && (
                  <Button schemaButton="full-primary" action={handleShowModal}>
                    Criar Dado Financeiro
                  </Button>
                )}
              </ContainerButtons>
            </ContainerFilter>
          </ButtonGroupEnd>

          <TableContainer>
            <Table id="dados-financeiros-tabela">
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: Colors.primary,
                    color: Colors.white,
                  }}
                >
                  {dadosFinanceirosVisibleColumns.includes("Status") && (
                    <TableHeader>Status</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes(
                    "Data de Inclusão"
                  ) && <TableHeader>Data de Inclusão</TableHeader>}
                  {dadosFinanceirosVisibleColumns.includes(
                    "Data de Exclusão"
                  ) && <TableHeader>Data de Exclusão</TableHeader>}
                  {dadosFinanceirosVisibleColumns.includes("Tipo Exclusão") && (
                    <TableHeader>Tipo de Exclusão</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes(
                    "Local de Pagamento"
                  ) && <TableHeader>Local de Pagamento</TableHeader>}
                  {dadosFinanceirosVisibleColumns.includes("Banco") && (
                    <TableHeader>Banco Débito Automático</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes("Agência") && (
                    <TableHeader>Agência Débito Automático</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes(
                    "Conta Corrente"
                  ) && (
                    <TableHeader>Conta Corrente Débito Automático</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes("Chave Pix") && (
                    <TableHeader>Chave Pix</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes(
                    "Acumulo Pagamento"
                  ) && (
                    <TableHeader>Acúmulo de Pagamento (em dias)</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes(
                    "Frequencia Parcelas"
                  ) && <TableHeader>Frequência Parcelas</TableHeader>}
                  {dadosFinanceirosVisibleColumns.includes("Valor Titular") && (
                    <TableHeader>Valor para titular</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes(
                    "Valor Dependente"
                  ) && <TableHeader>Valor por dependente</TableHeader>}
                  {dadosFinanceirosVisibleColumns.includes("Lotação") && (
                    <TableHeader>Lotação</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes("Imprimir") && (
                    <TableHeader>Imprimir</TableHeader>
                  )}
                  {dadosFinanceirosVisibleColumns.includes("Observação") && (
                    <TableHeader>Observação</TableHeader>
                  )}
                  <TableHeader>Ações</TableHeader>
                </TableRow>
              </TableHead>
              <tbody>
                {dadosFinanceiros.length === 0 ? (
                  <TableRow>
                    <TableData
                      colSpan={dadosFinanceirosVisibleColumns.length + 1}
                      className="text-center text-muted"
                    >
                      Não há dados financeiros cadastrados.
                    </TableData>
                  </TableRow>
                ) : (
                  dadosFinanceiros
                    .slice()
                    .sort((a, b) => b.id - a.id)
                    .map((dados, idx) => (
                      <TableRow key={`dados-financeiros-${idx}`}>
                        {dadosFinanceirosVisibleColumns.includes("Status") && (
                          <TableData
                            style={{
                              color: dados.dataExclusao ? "" : Colors.success,
                              fontWeight: "600",
                            }}
                          >
                            {dados.dataExclusao ? "Inativo" : "Ativo"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Data de Inclusão"
                        ) && (
                          <TableData>
                            {dados.dataInclusao
                              ? dados.dataInclusao
                                  .split("-")
                                  .reverse()
                                  .join("/")
                              : "-"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Data de Exclusão"
                        ) && (
                          <TableData>
                            {dados.dataExclusao
                              ? dados.dataExclusao
                                  .split("-")
                                  .reverse()
                                  .join("/")
                              : "-"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Tipo Exclusão"
                        ) && (
                          <TableData>
                            {dados.dataExclusao ? dados.tipoExclusao?.nome : ""}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Local de Pagamento"
                        ) && (
                          <TableData>
                            {dados.localPagamento?.descricao || "Nenhum"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes("Banco") && (
                          <TableData>
                            {dados.bancoDebitoAutomatico || "Nenhum"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes("Agência") && (
                          <TableData>
                            {dados.agenciaDebitoAutomatico || "Nenhuma"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Conta Corrente"
                        ) && (
                          <TableData>
                            {dados.contaCorrenteDebitoAutomatico || "Nenhuma"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Chave Pix"
                        ) && (
                          <TableData>{dados.chavePix || "Nenhuma"}</TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Acumulo Pagamento"
                        ) && <TableData>{dados.acumulaPagamento}</TableData>}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Frequencia Parcelas"
                        ) && (
                          <TableData>
                            {dados.frequenciaParcela || "Nenhuma"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Valor Titular"
                        ) && (
                          <TableData>
                            {formatarValorEmReais(dados.valorTitular)}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Valor Dependente"
                        ) && (
                          <TableData>
                            {formatarValorEmReais(dados.valorDependente)}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes("Lotação") && (
                          <TableData>
                            {dados.lotacao?.descricao || "Nenhuma"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Imprimir"
                        ) && (
                          <TableData>
                            {dados.imprimir ? "Sim" : "Não"}
                          </TableData>
                        )}
                        {dadosFinanceirosVisibleColumns.includes(
                          "Observação"
                        ) && (
                          <TableData>{dados.observacao || "Nenhuma"}</TableData>
                        )}
                        <TableData
                          key={`actions-${dados.id}`}
                          style={{
                            position: "relative",
                            overflow: "visible",
                          }}
                        >
                          <ButtonAction
                            onClick={() => toggleDropdown(dados.id)}
                          >
                            {isOpenDropdown === dados.id ? (
                              <IoMdClose
                                cursor={"pointer"}
                                size={20}
                                style={{ color: Colors.primary }}
                              />
                            ) : (
                              <SlOptionsVertical
                                cursor={"pointer"}
                                size={20}
                                style={{ color: Colors.primary }}
                              />
                            )}
                          </ButtonAction>
                          <MenuTable
                            show={isOpenDropdown === dados.id}
                            align="start"
                            ref={(el: HTMLDivElement | null) => {
                              // Armazena a referência no mapa usando o ID do registro como chave
                              menuRefsMap.current.set(dados.id, el);
                            }}
                            isLastRows={
                              dadosFinanceiros.length > 0 &&
                              dadosFinanceiros.indexOf(dados) >=
                                dadosFinanceiros.length -
                                  Math.ceil(dadosFinanceiros.length / 2)
                            }
                          >
                            <MenuTableDivider />
                            <MenuTableItem
                              eventKey="1"
                              onClick={() => handleSelectDados(dados)}
                            >
                              Detalhes
                            </MenuTableItem>
                            <MenuTableDivider />
                          </MenuTable>
                        </TableData>
                      </TableRow>
                    ))
                )}
              </tbody>
            </Table>
          </TableContainer>
        </div>
        {contribuinteData && (
          <DadosFinanceirosModal
            show={showModal}
            onHide={() => {
              setShowModal(false);
              setSelectedDadoFinanceiro(undefined);
              setLastDadoFinanceiro(undefined);
            }}
            contribuinteData={contribuinteData}
            dadoFinanceiroToEdit={selectedDadoFinanceiro}
            lastDadoFinanceiro={lastDadoFinanceiro!}
            setSelectedTab={setSelectedTab}
            setCancelFutureInstallmentsIds={setCancelFutureInstallmentsIds}
            newFlow={newFlow}
            setNewFlow={setNewFlow}
            fetchDadosFinanceiros={fecthDadosFinanceiros}
            editOnly={editOnly}
          />
        )}
      </div>
    </MainContainer>
  );
};

export default DadosFinanceirosList;
